/** ToneJS based Wav player */

import { logger } from '@tunasong/models'
import { PolySynth, Synth } from 'tone'
import { midiToNote } from '../events/index.js'
import type { MidiNoteEvent } from '../events/index.js'
import type { AudioInstrument } from './instrument.js'

export class BasicSynth extends PolySynth implements AudioInstrument {
  constructor() {
    super({
      voice: Synth,
    })
  }
  /** @param time when to play, in AudioContext-clock seconds — see AudioInstrument.onEvent (GH #1501). */
  onEvent(event: MidiNoteEvent, time?: number): void {
    logger.debug(`BasicSynth play`, event)

    const { type, note } = event
    const name = midiToNote(note.number)
    /**  Handle events  */
    if (type === 'noteon') {
      const { value: velocity } = event
      this.triggerAttack(name, time, velocity as number)
    } else if (type === 'noteoff') {
      this.triggerRelease(name, time)
    } else {
      throw new Error(`Unknown event type ${type}`)
    }
  }
}
